import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        
        {/* Header Section */}
        <div className="bg-green-600 py-10 text-center">
          <h1 className="text-4xl font-extrabold text-white">About Delight Store</h1>
          <p className="mt-2 text-green-100 text-lg">Your Daily Needs, Delivered with Love.</p>
        </div>

        {/* Story Section */}
        <div className="p-8 space-y-6 text-gray-700 leading-relaxed">
          <p className="text-xl font-semibold text-gray-900">
            Welcome to <span className="text-green-600">Delight Store</span>! 🛍️
          </p>
          <p>
            We are not just an online shop; we are a part of the <strong>Goverdhan Enclave</strong> community. 
            Founded with a simple mission: to bring fresh groceries, daily essentials, and household items 
            directly to your doorstep without the hassle of crowded markets.
          </p>
          
          <div className="grid md:grid-cols-2 gap-6 my-8">
            <div className="bg-green-50 p-6 rounded-xl border border-green-100">
              <h3 className="font-bold text-green-800 text-lg mb-2">🚀 Fast Local Delivery</h3>
              <p>We specialize in ultra-fast delivery within Goverdhan Enclave and nearby sectors. Order now, get it soon!</p>
            </div>
            <div className="bg-orange-50 p-6 rounded-xl border border-orange-100">
              <h3 className="font-bold text-orange-800 text-lg mb-2">✅ Quality Guaranteed</h3>
              <p>We hand-pick every item. If you wouldn't buy it, we won't deliver it. Freshness is our promise.</p>
            </div>
          </div>

          <p>
            Whether you need morning milk, or emergency snacks, Delight Store is 
            always just a click away. Thank you for supporting a local business!
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;